import { render, staticRenderFns } from "./VehicleFeatures.vue?vue&type=template&id=501c00b8&lang=pug&"
import script from "./VehicleFeatures.vue?vue&type=script&lang=ts&"
export * from "./VehicleFeatures.vue?vue&type=script&lang=ts&"
import style0 from "./VehicleFeatures.vue?vue&type=style&index=0&id=501c00b8&prod&lang=sass&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports